import gql from 'graphql-tag'
export default gql`
  mutation updateControls ($key: String!, $value: String!, $merge: Controls) {
    updateControls(key: $key, value: $value, merge: $merge) @client
  }
`
